<template>
  <div class="crud_form_wrapper">
    <!-- Start:: Title -->
    <div class="form_title_wrapper">
      <h4>{{ $t("PLACEHOLDERS.show_contest") }}</h4>
    </div>
    <div class="col-12 text-end">
      <v-btn @click="$router.go(-1)" style="color: #7514b7">
        <i class="fas fa-backward"></i>
      </v-btn>
    </div>
    <!-- End:: Title -->

    <!-- Start:: Single Step Form Content -->
    <div class="single_step_form_content_wrapper">
      <form>
        <div class="row">
          <!-- ============= Start:: Contest Details Section ============= -->
          <div class="col-12">
            <h5 class="my-3">{{ $t("PLACEHOLDERS.contest_details") }}</h5>
          </div>

          <!-- Start:: Contest Name (Arabic) -->
          <base-input
            col="6"
            type="text"
            :placeholder="
              $t('PLACEHOLDERS.contest_name') +
              ' (' +
              $t('PLACEHOLDERS.ar') +
              ')'
            "
            v-model.trim="data.nameAr"
            disabled
          />
          <!-- End:: Contest Name (Arabic) -->

          <!-- Start:: Contest Name (English) -->
          <base-input
            col="6"
            type="text"
            :placeholder="
              $t('PLACEHOLDERS.contest_name') +
              ' (' +
              $t('PLACEHOLDERS.en') +
              ')'
            "
            v-model.trim="data.nameEn"
            disabled
          />
          <!-- End:: Contest Name (English) -->

          <!-- Start:: Contest Image Display -->
          <div class="col-12 mb-4 d-flex flex-column gap-2">
            <div
              class="input_wrapper d-flex flex-column gap-2 justify-content-center py-2"
            >
              <label>{{ $t("PLACEHOLDERS.contest_image") }}</label>
              <div class="image_preview_wrapper mt-2" v-if="data.contestImage">
                <img
                  :src="data.contestImage"
                  :alt="data.nameAr"
                  class="rounded"
                  style="
                    max-width: 300px;
                    max-height: 300px;
                    object-fit: contain;
                  "
                />
              </div>
            </div>
          </div>
          <!-- End:: Contest Image Display -->

          <!-- ============= Start:: Contest Duration Section ============= -->
          <div class="col-12">
            <h5 class="my-3">{{ $t("PLACEHOLDERS.contest_duration") }}</h5>
          </div>

          <!-- Start:: Start Date Input -->
          <base-input
            col="6"
            type="text"
            :placeholder="$t('PLACEHOLDERS.start_date')"
            v-model="data.startDate"
            disabled
          />
          <!-- End:: Start Date Input -->

          <!-- Start:: End Date Input -->
          <base-input
            col="6"
            type="text"
            :placeholder="$t('PLACEHOLDERS.end_date')"
            v-model="data.endDate"
            disabled
          />
          <!-- End:: End Date Input -->

          <!-- Start:: Contest Status -->
          <base-input
            col="6"
            type="text"
            :placeholder="$t('PLACEHOLDERS.contest_status')"
            v-model="data.statusLabel"
            disabled
          />
          <!-- End:: Contest Status -->

          <!-- ============= Start:: Sponsor Section ============= -->
          <div class="col-12">
            <h5 class="my-3">{{ $t("PLACEHOLDERS.sponsor_info") }}</h5>
          </div>

          <!-- Start:: Sponsor Name Input -->
          <base-input
            col="12"
            type="text"
            :placeholder="$t('PLACEHOLDERS.sponsor_name')"
            v-model.trim="data.sponsorName"
            disabled
          />
          <!-- End:: Sponsor Name Input -->

          <!-- Start:: Sponsor Image Display -->
          <div
            class="col-12 mb-4 d-flex flex-column gap-2"
            v-if="data.sponsorImage"
          >
            <div
              class="input_wrapper d-flex flex-column gap-2 justify-content-center py-2"
            >
              <label>{{ $t("PLACEHOLDERS.sponsor_image") }}</label>
              <div class="image_preview_wrapper mt-2">
                <img
                  :src="data.sponsorImage"
                  :alt="data.sponsorName"
                  class="rounded"
                  style="
                    max-width: 300px;
                    max-height: 300px;
                    object-fit: contain;
                  "
                />
              </div>
            </div>
          </div>
          <!-- End:: Sponsor Image Display -->

          <!-- ============= Start:: Contest Conditions Section ============= -->
          <div class="col-12">
            <h5 class="my-3">{{ $t("PLACEHOLDERS.contest_conditions") }}</h5>
          </div>

          <!-- Start:: Activity Input -->
          <base-input
            col="6"
            type="text"
            :placeholder="$t('PLACEHOLDERS.activity')"
            v-model="data.activityName"
            disabled
          />
          <!-- End:: Activity Input -->

          <!-- Start:: Condition Type -->
          <base-input
            col="6"
            type="text"
            :placeholder="$t('PLACEHOLDERS.condition_type')"
            v-model="data.conditionLabel"
            disabled
          />
          <!-- End:: Condition Type -->

          <!-- Start:: Condition Value Input -->
          <base-input
            col="12"
            type="number"
            :placeholder="$t('PLACEHOLDERS.condition_value')"
            v-model.number="data.conditionValue"
            disabled
          />
          <!-- End:: Condition Value Input -->

          <!-- ============= Start:: Contest Rewards Section ============= -->
          <div class="col-12">
            <h5 class="my-3">{{ $t("PLACEHOLDERS.contest_rewards") }}</h5>
          </div>

          <!-- Start:: Prize Type -->
          <base-input
            col="6"
            type="text"
            :placeholder="$t('PLACEHOLDERS.prize_type')"
            v-model="data.prizeLabel"
            disabled
          />
          <!-- End:: Prize Type -->

          <!-- Start:: Prize Value Input -->
          <base-input
            col="6"
            type="number"
            :placeholder="$t('PLACEHOLDERS.prize_value')"
            v-model.number="data.prizeValue"
            disabled
          />
          <!-- End:: Prize Value Input -->

          <!-- ============= Start:: Contest Type Section ============= -->
          <div class="col-12">
            <h5 class="my-3">{{ $t("PLACEHOLDERS.contest_type") }}</h5>
          </div>

          <!-- Start:: Contest Type -->
          <base-input
            col="12"
            type="text"
            :placeholder="$t('PLACEHOLDERS.contest_type')"
            v-model="data.typeLabel"
            disabled
          />
          <!-- End:: Contest Type -->

          <!-- Start:: Fees Input (Conditional) -->
          <base-input
            v-if="data.fees"
            col="12"
            type="number"
            :placeholder="$t('PLACEHOLDERS.contest_fees')"
            v-model.number="data.fees"
            disabled
          />
          <!-- End:: Fees Input (Conditional) -->

          <!-- ============= Start:: Additional Info Section ============= -->
          <div class="col-12">
            <h5 class="my-3">{{ $t("PLACEHOLDERS.additional_info") }}</h5>
          </div>

          <!-- Start:: Description (Arabic) -->

          <!-- End:: Description (English) -->

          <!-- Start:: Created Date -->
          <base-input
            col="6"
            type="text"
            :placeholder="$t('PLACEHOLDERS.created_at')"
            v-model="data.createdAt"
            disabled
          />
          <!-- End:: Created Date -->

          <!-- Start:: Updated Date -->
          <base-input
            col="6"
            type="text"
            :placeholder="$t('PLACEHOLDERS.updated_at')"
            v-model="data.updatedAt"
            disabled
          />
          <!-- End:: Updated Date -->
          <base-input
            col="6"
            type="textarea"
            :placeholder="$t('PLACEHOLDERS.descriptionAr')"
            v-model="data.descriptionAr"
            :maxLength="500"
            disabled
          />
          <base-input
            col="6"
            type="textarea"
            :placeholder="$t('PLACEHOLDERS.descriptionEn')"
            v-model="data.descriptionEn"
            :maxLength="500"
            disabled
          />
          <!-- Start:: Status Switch Input -->
          <div class="input_wrapper switch_wrapper my-5 col-12">
            <v-switch
              color="green"
              :label="
                data.isActive
                  ? $t('PLACEHOLDERS.active')
                  : $t('PLACEHOLDERS.notActive')
              "
              v-model="data.isActive"
              hide-details
              disabled
            ></v-switch>
          </div>
          <!-- End:: Status Switch Input -->
        </div>
      </form>
    </div>
    <!-- END:: Single Step Form Content -->
  </div>
</template>

<script>
export default {
  name: "ShowContest",

  data() {
    return {
      // Start:: Loader Control Data
      isWaitingRequest: false,
      // End:: Loader Control Data

      // Start:: Data Collection To Display
      data: {
        nameAr: null,
        nameEn: null,
        contestImage: null,
        sponsorImage: null,
        startDate: null,
        endDate: null,
        sponsorName: null,
        activityName: null,
        conditionLabel: null,
        conditionValue: null,
        prizeLabel: null,
        prizeValue: null,
        typeLabel: null,
        fees: null,
        statusLabel: null,
        descriptionAr: null,
        descriptionEn: null,
        isActive: false,
        createdAt: null,
        updatedAt: null,
      },
      // End:: Data Collection To Display
    };
  },

  computed: {
    // Activities List
    activities() {
      return [
        { id: 1, name: this.$t("ACTIVITIES.walking_running") },
        { id: 2, name: this.$t("ACTIVITIES.cycling") },
        { id: 3, name: this.$t("ACTIVITIES.horse_riding") },
      ];
    },
  },

  methods: {
    // Start:: Show Contest Data
    async showContest() {
      try {
        let res = await this.$axios({
          method: "GET",
          url: `contests/${this.$route.params.id}`,
        });

        const contest = res.data.data.Contest || res.data.data;

        // Set contest data
        this.data.nameAr = contest.trans?.name?.ar || contest.name;
        this.data.nameEn = contest.trans?.name?.en || contest.name;
        this.data.contestImage = contest.contest_image;
        this.data.sponsorImage = contest.sponsor_image;
        this.data.startDate = contest.start_date;
        this.data.endDate = contest.end_date;
        this.data.sponsorName = contest.sponsor_name;
        this.data.conditionLabel = contest.condition_label;
        this.data.conditionValue = contest.condition_value;
        this.data.prizeLabel = contest.prize_label;
        this.data.prizeValue = contest.prize_value;
        this.data.typeLabel = contest.type_label;
        this.data.fees = contest.fees;
        this.data.statusLabel = contest.status_label;
        this.data.descriptionAr = contest.description_ar || "";
        this.data.descriptionEn = contest.description_en || "";
        this.data.isActive = contest.is_active;
        this.data.createdAt = contest.created_at;
        this.data.updatedAt = contest.updated_at;

        // Set activity name from object
        this.data.activityName = contest.activity?.name || "";
      } catch (error) {
        console.log(error.response?.data?.message);
        this.$message.error(
          error.response?.data?.message || this.$t("MESSAGES.somethingWrong")
        );
      }
    },
    // End:: Show Contest Data
  },

  created() {
    // Start:: Fire Methods
    this.showContest();
    // End:: Fire Methods
  },
};
</script>

<style scoped>
.description_content {
  padding: 12px;
  border: 1px solid #e0e0e0;
  border-radius: 4px;
  background-color: #f5f5f5;
  min-height: 60px;
}
</style>
